import EntryActionTypes from '../constants/EntryActionTypes';

const fetchMonthlyReportInCurrentBoard = (year, month, listId, pointSystemId = null) => ({
  type: EntryActionTypes.MONTHLY_REPORT_IN_CURRENT_BOARD_FETCH,
  payload: {
    year,
    month,
    listId,
    pointSystemId,
  },
});

export default {
  fetchMonthlyReportInCurrentBoard,
};

